// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;

import VendorScriptLoader from './utility/vendor-script-loader';
import LazyLoad from './utility/lazy-load';
import AnchorSmoothScroll from './utility/anchor-smooth-scroll';
import HeaderNav from './components/header-nav';
// import NavLinkToggler from './utility/nav-link-toggler';

// Temporary usage until we set up Borlabs v3
// import './fonts';

// Google Maps :: when loading the Google Maps js API a callback is required to be passed, but since
// we are already firing an event when the script is loaded, there's no need for this callback.
// We define it just to avoid the console error.
window.initMap = () => {};

/**
 * Code-splitting :: Blocks
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if ( document.querySelector('.js-example-block') ) {
    import('~scripts/blocks/example');
  }

  if (document.querySelector('.js-image-carousel-block')) {
    import('~scripts/blocks/image-carousel');
  }

  if (document.querySelector('.js-icon-tiles-block')) {
    import('~scripts/blocks/icon-tiles');
  }

  if (document.querySelector('.js-images-tiles-block')) {
    import('~scripts/blocks/images-tiles');
  }

  if (document.querySelector('.js-slides-block')) {
    import('~scripts/blocks/slides-block').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-tabbed-block')) {
    import('~scripts/blocks/tabbed-block').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-stats-box-block')) {
    import('~scripts/blocks/stats-right-text-left');
  }

  if (document.querySelector('.js-faqs-block')) {
    import('~scripts/blocks/faqs');
  }

  if (document.querySelector('.js-table-block')) {
    import('~scripts/blocks/table');
  }

  if (document.querySelector('.js-offices-tiles-block')) {
    import('~scripts/blocks/offices-tiles');
  }

  if (document.querySelector('.js-logo-carousel-block')) {
    import('~scripts/blocks/logo-carousel');
  }

  if (document.querySelector('.js-contact-form-block')) {
    import('~scripts/blocks/contact-form');
  }

  if (document.querySelector('.js-related-insights-block')) {
    import('~scripts/blocks/related-insights');
  }

  if ( document.querySelector('.js-map') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('google-maps:loaded', () => {
      // alert('Google Maps loaded');
    });

    VendorScriptLoader.outputGoogleMapsScriptTag();
  }

  if ( document.getElementById('feed') ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('~scripts/blocks/feed');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-pinia']);
  }

  // TODO - there's an issue with VendorScriptLoader when loading different components, on the same page, using similar vendor files. This causes a race condition and the last component to load will error out. To enable this demo component you will need to disable Feed component, if in use.
  // if ( document.getElementById('lottie-vue-example') ) {
  //   // Loads component only after vendor files are loaded
  //   document.addEventListener('multiple-vendors:loaded', () => {
  //     import('~scripts/blocks/vue-lottie-example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTags(['vendor-vue']);
  // }
}

/**
 * Code-splitting :: Components
 *
 * Manages components that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  // if ( document.querySelector('.js-example-component') ) {
  //   // Loads component only after vendor file is loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

  if ( document.querySelector('.js-example-component') ) {
    import('~scripts/components/example');
  }

  // TODO - there's an issue with VendorScriptLoader when loading different components, on the same page, using similar vendor files. This causes a race condition and the last component to load will error out. To enable this demo component you will need to disable Feed component, if in use.
  // if ( document.getElementById('js-vue-demo-components') ) {
  //   // Loads component only after vendor files are loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/vue-demo-components');
  //   });

  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

 

  // Search Overlay
  if ( document.querySelector('.js-search-overlay') ) {
    import('~scripts/components/search-overlay').then(component => {
      component.default.init();
    });
  }

  // Form :: custom choice fields
  if ( document.querySelectorAll('.form-style select').length ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-choices:loaded', () => {
      import('~scripts/components/form/form-custom-select-styles').then(component => {
        component.default.init('.form-style');
      });
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-choices');
  }

  // Form :: field validation feedback
  if ( document.querySelectorAll('.form-style').length ) {
    import('~scripts/components/form/form-field-validation-feedback').then(component => {
      const FormFieldValidationFeedback = component.default;
      FormFieldValidationFeedback.init('.form-style');
    });
  }

  // Generic form (i.e. search form)
  if ( document.querySelectorAll('.js-generic-form  select').length ) {
    import('~scripts/components/form/generic-form-custom-select-styles').then(component => {
      component.default.init('.js-generic-form');
    });
  }

  // Wordpress pagination
  if ( document.querySelector('.js-wp-pagination') ) {
    import('~styles/components/wp-pagination/index.scss');
  }

  if ( document.querySelector('.js-video-autoplay') ) {
    import('~scripts/components/video/video-autoplay').then(component => {
      component.default.init();
    });
  }

  if ( document.querySelector('.js-lottie-file') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-lottie-player:loaded', () => {
      import('~scripts/components/lottie-file');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-player');
  }

  // Custom horizontal scrollbar
  if ( document.querySelector('.js-horizontal-scrollbar') ) {
    import('~scripts/components/custom-scrollbar/horizontal-scrollbar').then(component => {
      const HorizontalScrollbar = component.default;

      // Adjusts custom scrollbar's width so that it corresponds to the difference in widths
      // between the scrollable content and the scrollbar area.
      // This function will have 1 argument: 'instance'
      const calculateScrollbarWidthOffsetFn = () => {
        // const scrollbarContainerRightPos = instance._customScrollbarContainerEl.getBoundingClientRect().right;
        // const viewportWidth = window.innerWidth;
        //
        // // Calculate the space between the scrollbar's right edge and the viewport's right edge
        // const space = Math.floor(viewportWidth - scrollbarContainerRightPos);
        //
        // return space / 2;

        return 0;
      };

      document.querySelectorAll('.js-horizontal-scrollbar').forEach(node => {
        new HorizontalScrollbar(node, calculateScrollbarWidthOffsetFn);
      });
    });
  }

  // if ( document.querySelector('.js-simple-accordion') ) {
  //   import('~scripts/components/accordion/simple-accordion').then(component => {
  //     const SimpleAccordion = component.default;
  //
  //     document.querySelectorAll('.js-simple-accordion').forEach(node => {
  //       new SimpleAccordion(node);
  //     });
  //   });
  // }


  if ( document.querySelector('.js-dev-styles-guide') ) {
    import('~styles/components/dev-styles-guide/index.scss');
  }

}


/**
 * DOMContentLoaded events should be listened to on this file only.
 */
document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerComponents);

/**
 * Load common components here
 */
document.addEventListener('DOMContentLoaded', () => {
  // Example
  // // Initiates Header Nav Menu
  HeaderNav.init();

  // Applies lazy-loading to images on the page
  LazyLoad.init();

  // Initiates Anchor Smooth Scroll utility
  AnchorSmoothScroll.init();

  // Navigation link toggler for current active item
  // NavLinkToggler.init();

  window.addEventListener('borlabs-cookie-after-init', () => {
    registerVideoBlocks();
  });

  window.addEventListener('DOMContentLoaded', () => {
    registerVideoBlocks();
  });

  window.addEventListener('borlabs-cookie-consent-saved', () => {
    registerVideoBlocks();
  });
});
/*
 * Loads video blocks' JS only after Borlabs consent has been given to render videos.
 * This allows the code needed to play the videos to run after the user interacts
 * with Borlabs.
 */
function registerVideoBlocks() {

  
  // Checks consent for 'essential' group AS AN EXCEPTION for AES, since they only operate in the UK
  // and sorting out the video would be a complex and redundant operation for this particular client only.
  if (!hasConsentForVideoElements('essential')) {
    // No consent given, do not render blocks
    return;
  }

  if (document.querySelector('.js-video-player')) {
    import('~scripts/components/video/video-player').then(component => {
      component.default.init();
    });
  }

  if (document.querySelector('.js-video-player-autoplay')) {
    import('~scripts/components/video/video-autoplay').then(component => {
      component.default.init();
    });
  }
}

/**
 * Borlabs :: check for consent on loading Video elements
 */
function hasConsentForVideoElements(serviceGroupName = 'external-media') {
  let canInitiate = false;

  // Borlabs is not active
  if (typeof window.BorlabsCookie === 'undefined') {
    canInitiate = true;
  }

  // Borlabs is enabled
  else {
    // If we have third-party content that we want to load under "Essential" group which is also
    // code-split, we need to handle them separately to avoid early execution of code. This is
    // because Borlabs might still block content under "Essential" (i.e. Vimeo) until the user interacts
    // with the Borlabs Dialog box.
    if (serviceGroupName === 'essential') {
      if (window.BorlabsCookie.Consents.hasConsent('vimeo') || window.BorlabsCookie.Consents.hasConsent('youtube')) {
        canInitiate = true;
      }
    }

    else if (window.BorlabsCookie.Consents.hasConsentForServiceGroup(serviceGroupName)) {
      canInitiate = true;
    }

    else if (window.BorlabsCookie.Consents.hasConsent('vimeo') || window.BorlabsCookie.Consents.hasConsent('youtube')) {
      canInitiate = true;
    }
  }

  
  

  return canInitiate;
}